import { AgentDatasetSchema } from "@redotech/redo-model/agents/agent-dataset";
import * as zExt from "@redotech/rpc/ext";
import * as z from "zod/v4";

export const getDatasetById = {
  name: "getDatasetById" as const,
  input: z.object({ _id: zExt.objectId() }),
  output: AgentDatasetSchema,
};
